import * as React from 'react';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import { teal } from '@mui/material/colors';
import AutoGraphIcon from '@mui/icons-material/AutoGraph';
import Button from '@mui/material/Button';

export default function IconStatCard(props) {
  let {
    avatar,
    cardStyle,
    title,
    headerStyle = {},
    body,
    bodyStyle,
    bodyType,
    footer,
    footerStyle,
    footerButton,
    footerButtonOnClick
  } = props;

  let defaultAvatar =
    (<Avatar sx={{ bgcolor: teal[500] }} aria-label="recipe">
      <AutoGraphIcon />
    </Avatar>);
  const defaultBody = 0;
  const defaultFooter = "";
  let defaultFooterButton =
    (<Button variant="contained" style={{ background: teal[500] }} endIcon={<AutoGraphIcon />} onClick={footerButtonOnClick}>
      Manage
    </Button>);

  return (
    <Card sx={cardStyle ? cardStyle : { padding: "4px 8px", boxShadow: 'none' }}>
      <CardHeader
        avatar={
          avatar ? avatar : defaultAvatar
        }
        title={<Typography variant="body2" color="#9e9e9e"
          style={{
            fontFamily: 'Lato',
            color: 'rgb(117, 117, 117)',
            ...headerStyle
          }}
        >
          {title ? title : 'Title Text'}
        </Typography>}

      />
      <CardContent style={{ padding: "4px 8px", display: "initial" }}>
        {bodyType && bodyType === "div" ?
          <div style={bodyStyle ? bodyStyle : { textAlign: "center", fontSize: "1.8rem" }}>
            {body}
          </div>
          :
          <Typography variant="body2" color="#9e9e9e"
            style={bodyStyle ? bodyStyle : { fontFamily: 'Lato', textAlign: "center", fontSize: "1.8rem" }}>
            {body ? body : defaultBody}
          </Typography>
        }
        {footer ?
          <Typography variant="body2" color="#9e9e9e"
            style={footerStyle ? footerStyle : { fontFamily: 'Lato', textAlign: "center", fontSize: "1rem" }}>
            {footer}
          </Typography>
          :
          defaultFooter
        }
      </CardContent>
    </Card>
  );
}

